const getTargetElement = (element, constraint) => {
  if (constraint.targetElement) {
    return element.closest(constraint.targetElement);
  }

  return element;
};

export default getTargetElement;
